import React from 'react';

class ReadingMainQuestion extends React.Component{
    render(){
        //console.log(this.props.frageTitle.length)
        if(this.props.frageTitle.length==2){
            return (
                <div className="questionName centered">
                    <div className="questionHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                       {/* <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>*/}
                    </div>
                    <div className="questionMidHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                    </div>
                    {/*<div className="questionSecondHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[3]}}></p>
                    </div>*/}

                </div>
            );
        }else {
            return (
                <div className="questionName centered">
                    <div className="questionHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                    </div>
                    <div className="questionMidHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[2]}}></p>
                    </div>
                    <div className="questionSecondHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[3]}}></p>
                    </div>

                </div>
            );
        }
    }
}
export default ReadingMainQuestion;
